import { BooleanSearchAndFilterBondParams } from './type';

export const maturityFilters: BooleanSearchAndFilterBondParams[] = ['perpetual', 'lessThanFiveYears'];

export const isMaturityFilter = (field: BooleanSearchAndFilterBondParams): field is 'perpetual' | 'lessThanFiveYears' => maturityFilters.includes(field);
